export const THEME_ID = {
  KINDLY: 'kindly',
  KINDLY_CHRISTIAN: 'kindly-christian',
} as const;

export type ThemeId = (typeof THEME_ID)[keyof typeof THEME_ID];

export interface ThemeColors {
  'footer-bg': string;
  'button-primary': string;
  'button-primary-hover': string;
  'button-secondary': string;
  'button-secondary-hover': string;
  'peer-details-bg': string;
  primary: string;
  'primary-dark': string;
  'profile-circle': string;
  'profile-circle-hover': string;
  'profile-gradient-start': string;
  'profile-gradient-end': string;
  'connect-bg': string;
  'connect-bg-hover': string;
  'see-more': string;
  'see-more-hover': string;
  pill: string;
  accent: string;
  'arrow-disabled': string;
  /* Neutrals */
  black: string;
  white: string;
  'gray-light': string;
  'progress-bar-gray': string;
  'input-border-gray': string;
  'placeholder-gray': string;
  'muted-text-gray': string;
  'body-gray': string;
  'label-gray': string;
  'avatar-border-slate': string;
  'section-header-slate': string;
  'icon-slate': string;
  /* Semantic */
  'link-light': string;
  error: string;
  /* Status / UI */
  success: string;
  'success-hover': string;
  unavailable: string;
  'selected-border': string;
  'selected-bg': string;
  'accent-hover': string;
  /* Landing */
  'landing-cream': string;
  'landing-off-white': string;
  'landing-border': string;
  'slate-hover': string;
  /* Connect by Goal topic cards */
  'topic-card-divider': string;
  'topic-card-icon-1': string;
  'topic-card-icon-2': string;
}

export interface ThemeDefinition {
  id: ThemeId;
  name: string;
  colors: ThemeColors;
}
